import { Dimensions, FlatList, View } from "react-native"
import LiveParticipant from "@common/liveMode/liveV3/LiveParticipant"
import React, { useContext } from "react"
import { DimensionsContext } from "@common/utils/mobileUtils"

export const TutorGridLayoutM = (props) => {
    const {
        participants,
        onParticipantClick,
        onTrackClick,
        setLiveChatUserId,
        setAgentCheckpointsUserId,
        availableWindowHeight,
        tracksMap,
        style={}
    } = props

    const dimensions = useContext(DimensionsContext)

    const MAX_COL_NUM = 4

    const length = participants?.length

    const colNumberByLength = [1, 2, 2, 2, 3, 3, 3, 3, 3, 4]

    const columnsNumber = colNumberByLength?.[length - 1] || MAX_COL_NUM
    const rowsNumber = Math.min(3, Math.ceil(length / columnsNumber))

    const ITEM_HEIGHT = availableWindowHeight / rowsNumber
    const ITEM_WIDTH = dimensions?.width / columnsNumber

    const lastRowLength = length % columnsNumber
    const lastRowMargin = lastRowLength > 0 ? (columnsNumber - lastRowLength) * ITEM_WIDTH / 2 : 0

    return (
        <View style={{ flex: 1, alignItems: "center", ...style }}>
            <FlatList
                data={participants}
                renderItem={({ item, index }) => (
                    <View style={{
                        width: ITEM_WIDTH,
                        height: ITEM_HEIGHT,
                        alignItems: "center",
                        justifyContent: "center",
                        marginLeft: index > 0 && index % columnsNumber === 0 ? lastRowMargin : 0,
                    }}>
                        <LiveParticipant
                            key={item.id}
                            user={item}
                            userTracks={tracksMap?.[item.id] || []}
                            style={{
                                width: "80%",
                                height: "90%",
                            }}
                            containerStyle={{
                                borderRadius: 15,
                            }}
                            setLiveChatUserId={setLiveChatUserId}
                            setAgentCheckpointsUserId={setAgentCheckpointsUserId}
                            onParticipantClick={onParticipantClick}
                            onTrackClick={onTrackClick}
                            index={index}
                            isGridLayout={true}
                            showPopUp={true}
                        />
                    </View>
                )}
                numColumns={columnsNumber}
                getItemLayout={(data, index) => (
                    { length: ITEM_HEIGHT, offset: ITEM_HEIGHT * index, index }
                )}
                key={columnsNumber?.toString()}
                keyExtractor={(item, index) => index.toString()}
                style={{ width: dimensions?.width, flex: 1 }}
            />
        </View>
    )
}